export default __webpack_public_path__ + "assets/checkmark.ee08c79a.svg";